import jwtService from './JWTService';

export default jwtService;
